export const cities = [
  {
    name: "New York",
    img: "https://res.cloudinary.com/hello-tickets/image/upload/ar_1:1,c_fill,f_auto,q_auto,w_800/v1639448826/ignuqnj093e3v7tjot29.jpg",
  },
  {
    name: "Seoul",
    img: "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/14/10/2f/bb/south-korea.jpg?w=1400&h=1400&s=1",
  },
  {
    name: "Barcelona",
    img: "https://myspainvisa.com/wp-content/uploads/madrid-capital-of-spain-1024x683.jpg",
  },
  {
    name: "Cancun",
    img: "https://cdn.prod.website-files.com/645cf73a1399f9f6ed09a0e8/645cf73a1399f93eb009a93c_Hero-Mobile-Cancun.jpg",
  },
  {
    name: "London",
    img: "https://i.natgeofe.com/n/4def1048-f5e5-4973-ad3a-e188a97d363f/regents-street-london-england_2x3.jpg",
  },
  {
    name: "Tokyo",
    img: "https://thumbs.dreamstime.com/b/tokyo-akihabara-night-bright-billboard-signs-v-japan-july-neon-lights-advertisements-building-sides-busy-electronics-hub-81472098.jpg",
  },
  {
    name: "Toronto",
    img: "https://cdn.prod.website-files.com/60f5c54f037127a76f8f5a59/61a7ed1df97580f936ff5cc3_Toronto_cropped.png",
  },
];
